import { useCharity } from "../context/CharityContext";
import { CharityRoute } from "../types";

/**
 * Resolves the campaign's home route for the current visitor.
 * Signed-in participants come home to the leaderboard — it is their main
 * page — while visitors without a session come home to the campaign page,
 * which is where signing in and joining start.
 *
 * @returns The route the logo and back controls should return to
 */
export const useCharityHomeRoute = (): CharityRoute => {
  const { hasHouseholdSession } = useCharity();

  return hasHouseholdSession ? CharityRoute.Leaderboard : CharityRoute.Campaign;
};
